// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const AuratypesComponentVersion = {
  ComponentVersion1: 'v1',
  ComponentVersion2: 'v2',
} as const;
export type AuratypesComponentVersion =
  (typeof AuratypesComponentVersion)[keyof typeof AuratypesComponentVersion];

export function instanceOfAuratypesComponentVersion(value: any): boolean {
  for (const key in AuratypesComponentVersion) {
    if (Object.prototype.hasOwnProperty.call(AuratypesComponentVersion, key)) {
      if (
        AuratypesComponentVersion[
          key as keyof typeof AuratypesComponentVersion
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function AuratypesComponentVersionFromJSON(
  json: any,
): AuratypesComponentVersion {
  return AuratypesComponentVersionFromJSONTyped(json, false);
}

export function AuratypesComponentVersionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AuratypesComponentVersion {
  return json as AuratypesComponentVersion;
}

export function AuratypesComponentVersionToJSON(
  value?: AuratypesComponentVersion | null,
): any {
  return value as any;
}

export function AuratypesComponentVersionToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): AuratypesComponentVersion {
  return value as AuratypesComponentVersion;
}
